


























































































































import { Component, Prop, Vue, Ref, Watch } from "vue-property-decorator";
import Editor from "vue-image-markup";
import Tools from "@/components/drawing-canvas/Tools.vue";
import ColorPicker from "@/components/drawing-canvas/ColorPicker.vue";

@Component({
  components: {
    Editor,
    Tools,
    ColorPicker
  }
})
export default class DrawingCanvasBlank extends Vue {
  @Prop() image!: string | null;
  @Prop() width!: number | string;
  @Prop() height!: number | string;
  @Prop() name!: string;
  @Prop({ type: Boolean, default: false }) readonly clearTool!: boolean;
  @Prop({ type: Boolean, default: false }) readonly pencilTool!: boolean;
  @Prop({ type: Boolean, default: false }) readonly textTool!: boolean;
  @Prop({ type: Boolean, default: false }) readonly arrowTool!: boolean;
  @Prop({ type: Boolean, default: false }) readonly moveTool!: boolean;
  @Prop({ type: Boolean, default: false }) readonly eraserTool!: boolean;
  @Prop({ type: Boolean, default: false }) readonly rectTool!: boolean;
  @Prop({ type: Boolean, default: false }) readonly circleTool!: boolean;
  @Prop({ type: Array, default: () => ["black"] }) readonly colors!: string[];
  @Prop({ default: null }) readonly defaultImage!: string | null;

  @Ref() readonly editor;

  // defaultImage = require("@/assets/img/body_w.png");
  color = "black";

  get canvasId() {
    return "canvas-" + this.name;
  }

  get disableUndo() {
    return false;
    // if (!this.isMounted) return true;

    // return this.editor.history.length < 2;
  }

  get disableRedo() {
    return false;
    // if (!this.isMounted) return true;

    // if (this.editor.history.length >= this.historyCount) {
    //   this.historyCount = this.editor.history.length;
    //   return true;
    // }

    // return false;
  }

  get attachedImage() {
    return this.image ?? this.defaultImage;
  }

  mounted() {
    this.editor.getObjectsById(this.canvasId);

    this.editor.setBackgroundImage(this.attachedImage);
  }

  mouseLeave() {
    console.log("mouse leave!");

    this.saveImage();
  }

  mouseEnter() {
    console.log("mouse enter!");
  }

  saveImage() {
    const hasDrawing = this.editor.canvas.getObjects().length > 0;

    this.$emit("createImage", hasDrawing ? this.editor.saveImage() : "");
  }

  freeDrawing() {
    const customizeFreeDrawing = { stroke: this.color, strokeWidth: 3 };
    this.editor.set("freeDrawing", customizeFreeDrawing);
  }

  helperForTextMode() {
    // helper untuk mengatasi bug text mode fabric js Cannot read properties of undefined (reading 'toLowerCase') at klass.getFontCache
    const opt = {
      overlayOpacity: "0",
      hasControl: false,
      width: 1,
      height: 1
    };
    this.editor.set("crop", opt);
  }

  textMode() {
    this.helperForTextMode();

    const opt = {
      id: "title",
      fill: this.color,
      fontFamily: "Verdana",
      fontSize: 13,
      placeholder: "Type something"
    };

    setTimeout(() => {
      this.editor.set("text", opt);
    }, 5);
  }

  selectMode() {
    this.editor.set("selectMode");
  }

  arrowMode() {
    const customizeArrow = { stroke: this.color, strokeWidth: 2 };
    this.editor.set("arrow", customizeArrow);
  }

  eraseMode() {
    this.editor.set("eraser");
  }

  rectMode() {
    const customizeRectangle = { strokeWidth: 5 };
    this.editor.set("rect", customizeRectangle);
  }

  circleMode() {
    const customizeCircle = { strokeWidth: 5 };
    this.editor.set("circle", customizeCircle);
  }

  undoMode() {
    this.editor.undo();
  }

  clearMode() {
    this.editor.clear();
    this.image = null;
    this.editor.setBackgroundImage(this.attachedImage);
    // this.clearCanvasHistory();
  }

  redoMode() {
    this.editor.redo();
  }

  changeColor(colorHex) {
    this.color = colorHex;
    this.editor.changeColor(colorHex);
  }

  // clearCanvasHistory() {
  //   this.editor.history.splice(0);
  //   this.historyCount = this.editor.history.length;
  // }

  @Watch("attachedImage")
  changedAttachedImage(val) {
    this.editor.setBackgroundImage(val);
  }
}
